import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Eye, Pencil } from 'lucide-react';
import LangEnum from '../../lang/LangEnum';
import { ShowroomTestIds } from '../../utils/testIds/Showroom.testIds';
import { useTranslation } from '../translation/TranslationContext';
import { ShowroomStorefrontViewMode } from './showroomStorefront.types';

interface Props {
  viewMode: ShowroomStorefrontViewMode;
  onClick: () => void;
}

const EditButton = ({ viewMode, onClick }: Props) => {
  const { translate } = useTranslation();

  if (viewMode === 'VISUALIZATION') {
    return (
      <Button
        size="medium"
        variant="contained"
        color="primary"
        testId={ShowroomTestIds.FEATURED_EDIT_SHOWROOM_DETAILS}
        startIcon={<Icon icon={Pencil} />}
        onClick={onClick}
      >
        {translate(LangEnum.GLOBAL_EDIT)}
      </Button>
    );
  }

  return (
    <Button
      size="medium"
      variant="contained"
      color="secondary"
      startIcon={<Icon icon={Eye} />}
      onClick={onClick}
    >
      {translate(LangEnum.GLOBAL_VIEW)}
    </Button>
  );
};

export default EditButton;
